export default __webpack_public_path__ + "static/media/Discord-Logo-White.958d6cb7.svg";